<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div class="info-table-item">
            <vue-select
              :options="servicosDisponiveis"
              placeholder="Serviços"
              @input="onChangeFilter"
              :clearable="true"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>

          <div class="info-table-item">
            <Subtitle
              @exibirVerdes="exibirVerdes"
              @exibirVermelhos="exibirVermelhos"
            />
          </div>

          <div class="info-table-item">
            <DownloadFiles
              :callback-pdf="generatePdf"
              :data="displayedCadastros"
              :fields="dataFields"
              name="estabelecimentos-equipes-servicos"
            />
          </div>
        </div>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            show-expand
            :single-expand="true"
            :expanded.sync="expanded"
            :item-class="getRowColor"
          >
            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <template v-slot:expanded-item="{ headers, item }">
              <td colspan="9">
                <div class="table-expanded">
                  <div class="servicos-equipe">
                    <h6>Serviços</h6>

                    <div class="servicos-grid">
                      <b-form-checkbox
                        v-for="servico in servicosDisponiveis"
                        :key="servico"
                        v-model="item.servicos"
                        :value="servico"
                      >
                        {{ servico }}
                      </b-form-checkbox>
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary btn-sm mt-3"
                      :disabled="
                        salvandoServicos !== null &&
                        salvandoServicos === item.nu_cnes
                      "
                      @click="salvarServicos(item)"
                    >
                      <b-spinner
                        v-if="
                          salvandoServicos !== null &&
                          salvandoServicos === item.nu_cnes
                        "
                        small
                        class="mr-1"
                      ></b-spinner>

                      {{
                        salvandoServicos !== null &&
                        salvandoServicos === item.nu_cnes
                          ? 'Salvando...'
                          : 'Salvar serviços'
                      }}
                    </button>
                  </div>

                  <hr />

                  <h6>Equipes vinculadas</h6>
                  <table class="table table-interna">
                    <thead>
                      <tr>
                        <th>INE</th>
                        <th>Equipe</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{
                            item.equipe_vinculada != null
                              ? item.equipe_vinculada.nu_ine
                              : ''
                          }}
                        </td>
                        <td>
                          {{
                            item.equipe_vinculada != null
                              ? item.equipe_vinculada.no_equipe
                              : ''
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <b-alert v-if="isInconsistente(item)" variant="danger" show>
                    Equipe inativa ou sem equipe vinculada. Para reativá-la, o
                    administrador do e-SUS municipal deve baixar o arquivo XML
                    no SIAPS ou SISAB e importar na aba CNES do Prontuário
                    Eletrônico ou Centralizador municipal.
                  </b-alert>
                </div>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import Subtitle from './Subtitle.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import * as Functions from './functions.js'
import { dataFields } from './utils.js'

export default {
  components: {
    Subtitle,
    DownloadFiles,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'Unidade de saúde',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Tipo equipe',
          align: 'start',
          filterable: false,
          value: 'sg_tipo_equipe',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      servicoSelecionado: null,
      servicosDisponiveis: [
        'ESF',
        'ESB',
        'EAP',
        'CAPS',
        'UPA',
        'CEO',
        'SESB',
        'LRPD',
        'EMULTI',
        'PADI',
        'PSE',
        'IAF',
      ],
      salvandoServicos: null,
      filtroConsistencia: null,
      dataFields: { ...dataFields },
      filterSearchTable: false,
    }
  },
  watch: {
    search: {
      handler(newValue) {
        if (newValue) {
          this.filterSearchTable = this.filterItems(newValue)
          return
        }

        this.filterSearchTable = false
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      let items = this.cadastros.map((item, index) => {
        let dados = {}
        let servicos = []

        try {
          if (typeof item.dados === 'string') {
            dados = JSON.parse(item.dados)
          } else if (item.dados && typeof item.dados === 'object') {
            dados = item.dados
          }
        } catch (error) {
          dados = {}
        }

        try {
          if (typeof item.servicos === 'string') {
            servicos = JSON.parse(item.servicos)
          } else if (Array.isArray(item.servicos)) {
            servicos = item.servicos
          }
        } catch (error) {
          servicos = []
        }

        const cadastro = {
          ...item,
          id: index,
          nu_cnes: dados?.nu_cnes ?? null,
          no_unidade_saude: dados?.no_unidade_saude ?? null,
          nu_ine: dados?.nu_ine ?? null,
          no_equipe: dados?.no_equipe ?? null,
          sg_tipo_equipe: dados?.sg_tipo_equipe ?? null,
          equipe_vinculada: dados?.equipe_vinculada ?? null,
          nu_ms: dados?.nu_ms ?? null,
          servicos,
        }

        return {
          ...cadastro,
          rowColor: this.isInconsistente(cadastro) ? 'red' : 'green',
        }
      })

      if (this.servicoSelecionado) {
        items = items.filter(
          (item) => item.sg_tipo_equipe === this.servicoSelecionado
        )
      }

      if (this.filtroConsistencia === 'verde') {
        items = items.filter((item) => !this.isInconsistente(item))
      }

      if (this.filtroConsistencia === 'vermelho') {
        items = items.filter((item) => this.isInconsistente(item))
      }

      return items
    },

    displayedCadastros() {
      if (this.filterSearchTable) {
        return this.filterSearchTable
      }

      return this.indexedItems
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     *
     * @param {String} search Texto digitado para pesquisa
     * @return {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()

      return this.indexedItems.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value] ?? '').toLowerCase()

            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }

        return false
      })
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Filtra os cadastros pelo tipo de equipe selecionado.
     *
     * @param {String|null} tipoEquipe Tipo de equipe selecionado
     */
    onChangeFilter(tipoEquipe) {
      this.servicoSelecionado = tipoEquipe
      this.search = ''
      this.currentPage = 1
      this.expanded = []
    },

    /**
     * Filtra os cadastros consistentes.
     *
     * @param {Boolean} checked Estado do filtro
     */
    exibirVerdes(checked) {
      this.filtroConsistencia = checked ? 'verde' : null
      this.search = ''
      this.currentPage = 1
      this.expanded = []
    },

    /**
     * Filtra os cadastros inconsistentes.
     *
     * @param {Boolean} checked Estado do filtro
     */
    exibirVermelhos(checked) {
      this.filtroConsistencia = checked ? 'vermelho' : null
      this.search = ''
      this.currentPage = 1
      this.expanded = []
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item Cadastro
     * @return {String}
     */
    getRowColor(item) {
      return this.isInconsistente(item)
        ? 'table-row-color-red'
        : 'table-row-color-green'
    },

    /**
     * Verifica se o cadastro possui alguma inconsistência.
     *
     * @param {Object} item Cadastro
     * @return {Boolean}
     */
    isInconsistente(item) {
      return (
        item.ine_ativo == 0 ||
        (item.nu_ms == 71 && item.equipe_vinculada == null) ||
        (item.nu_ms == 72 && item.equipe_vinculada == null)
      )
    },

    /**
     * Salva os serviços vinculados à equipe.
     *
     * @param {Object} item
     */
    async salvarServicos(item) {
      if (!item.servicos || item.servicos.length === 0) {
        this.$toast.warning(
          'Selecione pelo menos um serviço para salvar.',
          '',
          {
            position: 'topRight',
          }
        )
        return
      }

      try {
        this.salvandoServicos = item.nu_cnes

        const payload = {
          nu_cnes: item.nu_cnes,
          servicos: item.servicos,
        }

        await this.$api.post(
          '/app/municipio/' +
            this.$store.state.cod_ibge +
            '/equipes-saude/servicos',
          payload
        )

        this.$toast.success('Serviços atualizados com sucesso!', '', {
          position: 'topRight',
        })
      } catch (error) {
        console.log(error)

        this.$toast.error(
          'Erro ao atualizar os serviços! Por favor, tente novamente mais tarde.',
          '',
          {
            position: 'topRight',
          }
        )
      } finally {
        this.salvandoServicos = null
      }
    },

    /**
     * Gera o PDF com os cadastros exibidos.
     *
     * @return {void}
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.servicoSelecionado)
    },
  },
}
</script>

<style lang="scss">
#equipes-saude {
  .table-expanded {
    margin-top: 20px;

    table {
      margin-top: 10px;
    }
  }

  .servicos-equipe {
    margin-bottom: 20px;

    .servicos-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 25px;
      margin-top: 15px;

      .custom-control {
        flex: 0 0 60px;
        margin-right: 0;
      }
    }
  }

  @media (max-width: 768px) {
    .servicos-equipe {
      .servicos-grid {
        .custom-control {
          flex: 0 0 calc(50% - 15px);
        }
      }
    }
  }
}
</style>
